import React from 'react';

const PlainHeader = ({ title }) => (
  <div className="plain-header">
    <h1>{title}</h1>
  </div>
);

export default PlainHeader;



/** WEBPACK FOOTER **
 ** ./src/components/plain-header/index.js
 **/